import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';
import { SEARCH_TOOL_INVENTORY_ORDER_FOR } from '~/gql/tool-inventory-order-for';

export const useSearchToolOrderInventoryOrderFor = (fetchFromNetwork?: boolean) => {
  const [searchToolOrderInventoryOrderForQuery, { loading, data, error, networkStatus }] = useLazyQuery(
    SEARCH_TOOL_INVENTORY_ORDER_FOR
  );

  const searchToolOrderInventoryOrderFor = useCallback(
    (userProjectId: string, onComplete?: (data) => void) => {
      searchToolOrderInventoryOrderForQuery({
        variables: {
          userProjectId: userProjectId,
        },
        onCompleted: (data) => {
          if (onComplete) {
            onComplete(data);
          }
        },
        fetchPolicy: fetchFromNetwork ? 'network-only' : 'cache-first',
      });
    },
    [searchToolOrderInventoryOrderForQuery, fetchFromNetwork]
  );

  return { searchToolOrderInventoryOrderFor, data, loading, error, networkStatus };
};
